module.exports = {
  welcome: 'Welcome to CRO System'
}
